import { Col, Row, Select, Skeleton } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Learningchart from '../../student/studentprofile/studentprofilemain/charts/earningchart'
import { getStudents } from '../../../../api/class/class'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import { openNotificationWithIcon } from '../../../../utils/helper'
import Studentcard from './studentcard/studentcard'
import Friendsmodal from '../../student/studentprofile/studentfriends/friendsmodal/friendsmodal'

const Teacherstudents = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()

	const [currentStudent, setCurrentStudent] = useState(null)
	const [showStudent, setShowStudent] = useState(false)
	const [numOfStudents, setNumOfStudents] = useState(0)
	const [loading, setLoading] = useState(false)
	const [studentList, setStudentList] = useState([])
	const [totalFunPoints, setTotalFunPoints] = useState(0)
	const [totalFunKeys, setTotalFunKeys] = useState(0)


	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	const closeStudentModal = () => {
		setShowStudent(false)
	}

	const viewStudent = (studentDetails: any) => {
		setShowStudent(true)
		setCurrentStudent(studentDetails)
	}

	const fetchStudents = async () => {
		try {
			setLoading(true)
			const res = await getStudents(user?._id)
			const { data } = res?.data
			setStudentList(data)
			setLoading(false)
			setNumOfStudents(data.length)
			let newTotalFunPoints = 0
			let newTotalFunKeys = 0
			data.forEach((item: any) => {
				newTotalFunPoints += item.wallet.funPoints
				newTotalFunKeys += item.wallet.funKeys
			});
			setTotalFunPoints(newTotalFunPoints)
			setTotalFunKeys(newTotalFunKeys)
		} catch (error: any) {
			setLoading(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Get Curriculums', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Get Curriculums', 'Something went wrong')
			}
		}
	}

	useEffect(() => {
		fetchStudents()

		// eslint-disable-next-line
	}, [])


	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'Students',
			}
		})

		// eslint-disable-next-line
	}, [])

	return (
		<div className='min-h-screen pr-10 mt-4'>
			<div className='flex items-center'>
				<h1 className='mr-3 text-2xl font-medium text-appcolorblack'>
					Your Students
				</h1>
				<div id="select-class-area" className='w-[25%] mt-2'>
					<Select
						// loading={loadingClasses}
						placeholder="Search Student"
						className='w-full capitalize'
						//@ts-ignore
						getPopupContainer={() => document.getElementById('select-class-area')}
						onSelect={(value) => {

						}}
					>
						{/* {
							studentClasses.map((item: any) => (
								<Option key={item._id} value={item?._id} className="capitalize">
									{item.name}
								</Option>
							))
						} */}
					</Select>
				</div>
			</div>

			<div className='flex items-center justify-between mt-4'>
				<div className='flex items-center'>
					<p className='mr-2 text-sm text-appcolorwhitefaintsix'>
						Filter by Language
					</p>

					<img src="/img/vectors/curriculumpy.svg" alt="curriculumpy" className='' />
				</div>

				<div className='flex items-center cursor-pointer'>
					<div className='rounded-xl bg-appcolorgreyfaint mr-[0.6rem] p-[0.5rem]'>
						<img src="/img/vectors/filter.svg" alt="think" className='w-5 h-5 cursor-pointer' />
					</div>

					<p className='mr-2 text-sm text-appcolorwhitefaintsix'>
						Filter
					</p>
				</div>
			</div>

			<div className='mt-2 border-t-[3px] border-appcolorwhitefaintseven pt-[1.8rem]'>
				<Row gutter={32}>
					<Col xs={24} md={24} lg={15}>
						<div className='pl-1'>
							<p className='mr-3 text-lg font-medium text-appcolorblack'>
								Statistics
							</p>


							<div className='rounded-[30px] border border-appcolorwhite p-[1.5rem] custom-box-shadow-ten mt-4'>
								<Row>
									<Col xs={24} md={24} lg={8}>
										<div>
											<img src="/img/vectors/purpletimes.svg" alt="purpletimes" />

											<p className='mt-5 mb-1 text-sm font-medium text-appcolorfaintpurplefive'>
												Total Funkeys
											</p>

											<p>
												<span className='text-2xl font-medium text-appcolorpurpleeight'>{totalFunKeys}</span>
												{/* <span className='font-medium text-appcolorfaintpurplsix'>/100</span> */}
											</p>

											<div className='flex items-center mt-3'>
												{/* <span className='text-xs text-appcolorpurplenine'>
													12%
												</span> */}
												<img src="/img/vectors/increase.svg" alt="increase" className='px-1' />
												<span className='text-xs text-appcolorpurplenine'>
													increase
												</span>
											</div>

										</div>
									</Col>
									<Col xs={24} md={24} lg={8}>
										<div>
											<img src="/img/vectors/purpletimes.svg" alt="purpletimes" />

											<p className='mt-5 mb-1 text-sm font-medium text-appcolorfaintpurplefive'>
												Number of Students
											</p>

											<p>
												<span className='text-2xl font-medium text-appcolorpurpleeight'>
													{numOfStudents}
												</span>
												{/* <span className='font-medium text-appcolorfaintpurplsix'>/100</span> */}
											</p>

											<div className='flex items-center mt-3'>
												{/* <span className='text-xs text-appcolorpurplenine'>
													12%
												</span> */}
												<img src="/img/vectors/increase.svg" alt="increase" className='px-1' />
												<span className='text-xs text-appcolorpurplenine'>
													increase
												</span>
											</div>

										</div>
									</Col>
									<Col xs={24} md={24} lg={8}>
										<div>
											<img src="/img/vectors/purpletimes.svg" alt="purpletimes" />

											<p className='mt-5 mb-1 text-sm font-medium text-appcolorfaintpurplefive'>
												Cumulative Points
											</p>

											<p>
												<span className='text-2xl font-medium text-appcolorpurpleeight'>{totalFunPoints}</span><span className='font-medium text-appcolorfaintpurplsix'>Fps</span>
											</p>

											<div className='flex items-center mt-3'>
												{/* <span className='text-xs text-appcolorpurplenine'>
													12%
												</span> */}
												<img src="/img/vectors/increase.svg" alt="increase" className='px-1' />
												<span className='text-xs text-appcolorpurplenine'>
													increase
												</span>
											</div>

										</div>
									</Col>
								</Row>
							</div>

							<div className='mt-[2.5rem]'>
								<p className='text-[18px] text-appcolorblack leading-[107%] font-semibold mb-2'>
									Performance
								</p>

								<Row align="stretch" justify="start">
									<Col xs={24} md={24} lg={16}>
										<div className='mb-12'>
											<div>
												<Learningchart />
											</div>
										</div>
									</Col>
									<Col xs={24} md={24} lg={8}>
										<div className='h-[80%] p-4 rounded-2xl bg-appcolorwhitefaint'>
											<div className='flex flex-col flex-1'>
												<div className='flex mb-4'>
													<div className='bg-appcolorpurplefive rounded-[3px] h-[0.5rem] w-[0.5rem] mr-1 mt-1'></div>
													<div>
														<p className='mb-1 text-base font-semibold mb- text-appcolorblack'>FPs Earned</p>
														<p className='text-sm text-appcolorblack'>{totalFunPoints} FP</p>
													</div>
												</div>

												<div className='flex'>
													<div className='bg-appcolororangetwo rounded-[3px] h-[0.5rem] w-[0.5rem] mr-1 mt-1'></div>
													<div>
														<p className='mb-1 text-base font-semibold mb- text-appcolorblack'>Lessons Completed</p>
														<p className='text-sm text-appcolorblack'>0</p>
													</div>
												</div>
											</div>
										</div>
									</Col>
								</Row>
							</div>

							<div>
								<Row>
									<Col xs={24} md={24} lg={12}>
										<div>
											<p className='text-[18px] text-appcolorblack leading-[107%] font-semibold mb-2'>
												Your Star
											</p>
											<div className='mt-4'>
												{
													loading ?
														<>
															{
																[3, 4, 5].map((item) => (
																	<Skeleton.Button
																		key={`loading-students-${item}`}
																		active={true}
																		size={'large'}
																		shape={'square'}
																		block={true}
																		style={{
																			height: '4rem',
																			width: '100%',
																			marginBottom: '1rem'
																		}}
																	/>
																))
															}
														</>
														:
														<>
															{
																studentList?.length === 0 ?
																	<>
																		<p className='text-appcolorblackfainteleven tex-base'> Data currently unavailable</p>
																	</>
																	:
																	studentList.map((item: any, index: number) => (
																		<Studentcard
																			key={`your-students-${item?._id}`}
																			item={item}
																			index={index}
																		/>
																	))
															}
														</>
												}
											</div>

										</div>
									</Col>
									<Col xs={24} md={24} lg={12}>
										<div>
											<p className='text-[18px] text-appcolorblack leading-[107%] font-semibold mb-2'>
												Watch List
											</p>

											<div className='mt-4'>
												{
													loading ?
														<>
															{
																[3, 4, 5].map((item) => (
																	<Skeleton.Button
																		key={`loading-students-${item}`}
																		active={true}
																		size={'large'}
																		shape={'square'}
																		block={true}
																		style={{
																			height: '4rem',
																			width: '100%',
																			marginBottom: '1rem'
																		}}
																	/>
																))
															}
														</>
														:
														<>
															{
																studentList?.length === 0 ?
																	<>
																		<p className='text-appcolorblackfainteleven tex-base'> Data currently unavailable</p>
																	</>
																	:
																	studentList.map((item: any, index: number) => (
																		<Studentcard
																			key={`your-students-${item?._id}`}
																			item={item}
																			index={index}
																			offRankingNumber={true}
																		/>
																	))
															}
														</>
												}
											</div>
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</Col>
					<Col xs={24} md={24} lg={9}>
						<div>
							<div className=''>
								<p className='text-[18px] text-appcolorblack leading-[107%] font-semibold mb-2 border-b-[3px] border-appcolorwhitefaintseven pb-4'>
									Your Students
								</p>

								<div className='mt-4'>
									{
										loading ?
											<>
												{
													[3, 4, 5].map((item) => (
														<Skeleton.Button
															key={`loading-students-${item}`}
															active={true}
															size={'large'}
															shape={'square'}
															block={true}
															style={{
																height: '4rem',
																width: '100%',
																marginBottom: '1rem'
															}}
														/>
													))
												}
											</>
											:
											<>
												{
													studentList?.length === 0 ?
														<>
															<p className='text-appcolorblackfainteleven tex-base'> Data currently unavailable</p>
														</>
														:
														studentList.map((item: any, index: number) => (
															<Studentcard
																key={`your-students-${item?._id}`}
																item={item}
																index={index}
																showOptions
																viewStudent={viewStudent}
																offRankingNumber={true}
															/>
														))
												}
											</>
									}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			</div>

			{
				showStudent ?
					<Friendsmodal
						open={showStudent}
						closeModal={closeStudentModal}
						studentDetails={currentStudent}
						viewing="teacher"
					/>
					:
					null
			}
		</div>
	)
}

export default Teacherstudents